import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function ExchangeSourceSuccessNotification({ id, onDismiss, sourceName, targetName }) {
    const { t } = useTranslation();

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled variant={SnackbarVariant.SUCCESS}>
            <SnackbarMessage>
                {t(`notifications:ExchangeSourceSuccess`, {
                    source: sourceName,
                    target: targetName
                })}
            </SnackbarMessage>
        </Snackbar>
    );
}
